// from general.js
/* global isLoggedInOrRemembered toggleSignInOverlay isMobileDevice toggleAndPositionScreenAndOverlayIframe addToggleAndPositionScreenAndOverlayIframeCloseButton */
// from JSP?
/* global teacherId userId */


/**
 *  See also teacherClassroomPhotoUpdate.js
 */
export const showClassroomPhotoUploader = window.showClassroomPhotoUploader = function (el, event) {
    $(window).off('userCookiesReset.showClassroomPhotoUploader');
    if (!isLoggedInOrRemembered() || userId != teacherId) {
        toggleSignInOverlay(null, true);
        if (isMobileDevice) {
            $(window).on('userCookiesReset.showClassroomPhotoUploader', function () {
                window.location = el.href;
            });
        } else {
            $(window).on('userCookiesReset.showClassroomPhotoUploader', function () {
                showClassroomPhotoUploader(el, event);
            });
        }
        return;
    }

    if (!isMobileDevice) {
        toggleAndPositionScreenAndOverlayIframe('classroom-photo-iframe', el.href, event);
        $('#classroom-photo-iframe').closest('.overlay-iframe-wrapper').addClass('large');
        addToggleAndPositionScreenAndOverlayIframeCloseButton();
    }
}
